import React from 'react';
import { Zap, Plus, ArrowUpRight } from 'lucide-react';

const UseCasesPanel = ({ useCases, selectedUseCaseId, selectedDomainId, onSelectUseCase, onAddUseCase, onNavigateToUseCase }) => (
    <div className="col-span-1 md:col-span-3 bg-white rounded border border-gray-100 shadow-sm overflow-hidden flex flex-col h-full">
        <div className="px-4 py-3 border-b border-gray-100 flex items-center justify-between">
            <div className="flex items-center gap-2">
                <div className="w-7 h-7 rounded bg-primary/10 flex items-center justify-center">
                    <Zap className="w-3.5 h-3.5 text-primary" />
                </div>
                <span className="text-sm font-semibold text-gray-800">Use Cases</span>
            </div>
            <button
                disabled={selectedDomainId === null}
                onClick={onAddUseCase}
                className="w-6 h-6 hover:bg-gray-100 disabled:opacity-30 disabled:cursor-not-allowed rounded transition-colors flex items-center justify-center"
            >
                <Plus className="w-3.5 h-3.5 text-primary" />
            </button>
        </div>
        <div className="flex-1 overflow-y-auto p-2 space-y-1">
            {useCases.map((useCase, idx) => (
                <button
                    key={useCase.id}
                    onClick={() => onSelectUseCase(idx)}
                    className={`w-full text-left px-3 py-2.5 rounded text-sm font-medium transition-all duration-150 flex items-center justify-between group ${
                        selectedUseCaseId === idx
                            ? 'bg-secondaryLight text-secondary shadow-sm'
                            : 'text-gray-600 hover:bg-gray-50 hover:text-gray-900'
                    }`}
                >
                    <span className="truncate">{useCase.name}</span>
                    <button
                        onClick={(e) => { e.stopPropagation(); onNavigateToUseCase(useCase.id); }}
                        className={`flex-shrink-0 ml-1 opacity-0 group-hover:opacity-100 transition-opacity ${selectedUseCaseId === idx ? 'opacity-60' : ''}`}
                        aria-label="Go to use case"
                    >
                        <ArrowUpRight className="w-3.5 h-3.5" />
                    </button>
                </button>
            ))}
            {useCases.length === 0 && (
                <p className="text-gray-400 text-xs text-center py-6">
                    {selectedDomainId !== null ? 'No use cases yet' : 'Select a domain first'}
                </p>
            )}
        </div>
    </div>
);

export default UseCasesPanel;
